// components/Investments/InvestInFleets.jsx
/* eslint-disable @next/next/no-img-element */
import * as React from "react";
import { Box, Stack } from "@mui/material";
import CtaButton from "../buttonWithArrow";
import Heading from "../heading";

const MAX_W = 1300; // section content cap

export default function InvestInFleets({ data, onClick, bgcolor }) {
    if (!data) return null;
    const { sectionId, title, subtitle, image, button, width } = data;

    return (
        <Box
            component="section"
            id={sectionId}
            sx={{
                pt: { xs: 5, md: 8 },
                pb: { xs: 5, md: 8 },
                px: { xs: 2, sm: 3 },
                bgcolor: bgcolor ?? "#ffffff",
                scrollMarginTop: { xs: "80px", md: "96px" },
            }}
        >
            <Heading title={title} subtitle={subtitle} mb={6} />

            <Box sx={{ maxWidth: MAX_W, mx: "auto" }}>
                <Box
                    component="img"
                    src={`${process.env.IMAGE_BASE_URL}${image?.src}`}
                    alt={image?.alt}
                    loading="lazy"
                    sx={{
                        width: width ?? "100%",
                        maxWidth: "100%",
                        height: "auto",
                        display: "block",
                        mx: "auto",
                    }}
                />

                {button && (
                    <Stack alignItems="center" sx={{ mt: { xs: 3, md: 1 } }}>
                        <CtaButton label={button?.text} onClick={() => onClick && onClick()} />
                    </Stack>
                )}
            </Box>
        </Box>
    );
}
